import moment from 'moment'

export const localizeDate = (date, format = null) => {
    const localized = moment.utc(date).local()
    if (format) {
        return localized.format(format)
    }
    return localized
}

export const uuid = (len = 8, prefix = false) => {
  const id = Math.round((Math.random() * 36 ** len)).toString(36)
  return prefix ? `${prefix}${id}` : id
}

export const copyJSON = (source) => {
  try {
    return JSON.parse(JSON.stringify(source))
  } catch (err) {
    console.error(err)
  }
  return source
}